import './number'

import i18next from 'i18next'
import * as LanguageDetector from 'i18next-browser-languagedetector'
import * as XHR from 'i18next-xhr-backend'
import numeral from 'numeral'
import { reactI18nextModule } from 'react-i18next'

import { getDefaultSelectedLanguage } from '../../../core/services/storage.service'
import { getAppPath } from '../appHostPath'

const defaultNS = 'translations'

const laguagesAvailables: Array<string> = ['de', 'fr', 'it']

const getLanguageParamFromURL = () => {
  const urlSearchParams = new URLSearchParams(
    document.location.search.substring(1),
  )
  return urlSearchParams.get('lang')
}

export const getDefaultLanguage = () => {
  const defaultLang = 'de'

  const langFromStorage = getDefaultSelectedLanguage()
  if (
    langFromStorage &&
    langFromStorage !== null &&
    langFromStorage !== '' &&
    laguagesAvailables.indexOf(langFromStorage) > -1
  ) {
    return langFromStorage.slice(0, 2)
  }

  const languageParam = getLanguageParamFromURL()
  if (languageParam && laguagesAvailables.indexOf(languageParam) > -1) {
    return languageParam
  }

  const browserLanguage = navigator.language.slice(0, 2)
  if (laguagesAvailables.indexOf(browserLanguage) > -1) {
    return browserLanguage
  }

  return defaultLang
}

export function changeLanguageFromURL() {
  const languageParam = getLanguageParamFromURL()

  if (languageParam) {
    i18NextInstance.changeLanguage(languageParam)
  }
}

i18next
  .use(XHR)
  .use(LanguageDetector)
  .use(reactI18nextModule) // if not using I18nextProvider
  .init({
    fallbackLng: getDefaultLanguage(),
    debug: false,

    ns: defaultNS,
    defaultNS,
    fallbackNS: defaultNS,

    interpolation: {
      escapeValue: false, // not needed for react!!
    },
    // react i18next special options (optional)
    react: {
      wait: true, // Espera a tener los locales antes de pintar el componente
      nsMode: 'default',
    },
    backend: {
      loadPath: getAppPath() + 'locales/{{lng}}/{{ns}}.json',
    },
    initImmediate: false,
  })

i18next.on('languageChanged', function(lng) {
  numeral.locale(`${lng}-ch`)
})

export const i18NextInstance = i18next
